module.exports = __webpack_public_path__ + "static/sport/gallery-thumbs1.9045773.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/gallery-thumbs1.jpg
// module id = d6Xp
// module chunks = 0